import { combineReducers } from 'redux';

import {
  BILLING_REDIRECT_SET_NOTIFICATION_MESSAGE,
  BILLING_REDIRECT_SET_NOTIFICATION_TYPE,
} from '../../actions/billingRedirect/constant';
import createReducer from '../../utils/createReducer';

const notificationMessage = createReducer(null, {
  [BILLING_REDIRECT_SET_NOTIFICATION_MESSAGE]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.notifMessage,
});

const notificationType = createReducer(null, {
  [BILLING_REDIRECT_SET_NOTIFICATION_TYPE]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.notifType,
});

export default combineReducers({
  notificationMessage,
  notificationType,
});
